import * as React from "react";
import { WorkflowNode, Question, questionDefs } from "../../types";
import { Divider, FormGroup, ToggleGroup } from "../RightAsideHelpers";
import Input from "@/components/Input";
import TextArea from "@/components/TextArea";

interface Props {
  node: WorkflowNode;
  onUpdate: (node: Partial<WorkflowNode>) => void;
}

export default function SendEmailEditor({ node, onUpdate }: Props) {
  return (
    <>
      <FormGroup label="Mail To">
        <Input
          type="text"
          value={node.emailTo || ""}
          onChange={(emailTo) => onUpdate({ emailTo: emailTo })}
        />
      </FormGroup>
      <ToggleGroup
        toggled={node.sendTranscript || false}
        label="Send Conversation Transcript"
        changeToggle={() => {
          onUpdate({ sendTranscript: !node.sendTranscript });
        }}
      />

      {!node.sendTranscript && (
        <>
          <FormGroup label="Email Subject">
            <Input
              type="text"
              value={node.emailSubject || ""}
              onChange={(emailSubject) => onUpdate({ emailSubject })}
            />
          </FormGroup>
          <FormGroup label="Email Body">
            <TextArea
              value={node.emailBody || ""}
              onChange={(e) => onUpdate({ emailBody: e.currentTarget.value })}
            />
          </FormGroup>
        </>
      )}
    </>
  );
}
